import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';

import { Dropdown, Tooltip } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import { BRANCH_NAME, BUILD_DATE, BUILD_NUMBER, ENV, IS_PROD, VERTICAL_URL } from 'settings';
import apiService from 'v2/services/api';

import Topbar from '@eduzz/ui-layout/Topbar';

import { Details } from './Details';

type ApiVersion = {
  branchName: string;
  environment: string;
  version: number;
  versionDate: string;
};

export default () => {
  const [apiVersion] = useObservable(() => apiService.get<ApiVersion>('/version'), []);
  const [open, setOpen] = useState(false);

  if (IS_PROD || apiVersion === null) return null;

  const menuContent = (
    <div>
      <Details
        name='myeduzz-front'
        env={ENV}
        branch={`${BRANCH_NAME} ${BUILD_NUMBER}`}
        date={BUILD_DATE}
        redirect={`https://github.com/eduzz/myeduzz-front/tree/${BRANCH_NAME}`}
      />
      <Details
        name='myeduzz-api'
        env={apiVersion.environment}
        branch={apiVersion.branchName}
        date={apiVersion.versionDate}
        redirect={`https://github.com/eduzz/myeduzz-api/tree/${apiVersion.branchName}`}
        variant='api'
      />

      <Details
        name='myeduzz-vertical'
        env={'verificar'}
        branch={VERTICAL_URL}
        date={''}
        redirect={'https://github.com/eduzz/myeduzz-vertical'}
        variant='vertical'
      />
    </div>
  );

  return (
    <>
      <Tooltip title='Ambiente' placement='bottom' open={open ? false : undefined}>
        <span>
          <Dropdown
            open={open}
            onOpenChange={setOpen}
            dropdownRender={() => menuContent}
            trigger={['click']}
            placement='bottomRight'
          >
            <span>
              <Topbar.Action
                id='topbar-action-env'
                aria-label='mostrar config. ambiente'
                onClick={() => setOpen(!open)}
                icon={<Icon.Rocket className='text-(--uizz-antd-color-error)'  />}
              />
            </span>
          </Dropdown>
        </span>
      </Tooltip>
    </>
  );
};
